import type { ApiError } from '@empathyco/playboard-core-domain'
import type { IndexClientDTO, IndexClientFeedDTO } from '../models'
import type { IndexClientAdapter } from './interfaces'
import { injectable } from 'inversify'

export interface PlatformIndexClientEntity {
  token: string
  name: string
  feeds: Array<PlatformIndexClientFeed>
}

interface PlatformIndexClientFeed {
  id: string
  lastJobExecution?: string
  lastJobId?: string
  lastJobStatus?: string
}

export interface PlatformIndexClientError {
  status: number
  data?: any
}

@injectable()
export class PlatformIndexClientAdapter
  implements IndexClientAdapter<PlatformIndexClientEntity, PlatformIndexClientError>
{
  decode(payload: PlatformIndexClientEntity): IndexClientDTO {
    const { token, name, feeds } = payload ?? {}
    return {
      id: name,
      token,
      feeds: feeds?.map(feed => this.decodeFeed(feed)) ?? [],
    }
  }

  decodeError(error: PlatformIndexClientError): ApiError {
    return {
      status: error.status,
    }
  }

  private decodeFeed(feed: PlatformIndexClientFeed): IndexClientFeedDTO {
    const { id } = feed
    return {
      id,
    }
  }
}
